export const globalStoreAction = {
  SHOW_CONFIRMATION_POPUP: "SHOW_CONFIRMATION_POPUP",
  CLEAR_CONFIRMATION_POPUP: "CLEAR_CONFIRMATION_POPUP",
};

export const globalStoreState = {
  showConfirmationPopup: false
};

